export const QUERY_PARAMS = {
    SHOW_JOIN: 'show_join',
} as const;
